// This file is GENERATED by abweb/client/gulpfile.mjs - DO NOT EDIT!
export const ProjectVersion = "4.5.1-SNAPSHOT";
export const CacheBustVersionParam = "cacheBustVersion=4.5.1-SNAPSHOT-260419002500";
//# sourceMappingURL=GeneratedState.js.map
